/*
 * @Author: lijing
 * @Date: 2022-08-31 16:03:36
 * @Last Modified by: lijing
 * @Last Modified time: 2022-08-31 16:12:53
 */

import { useSelector } from "react-redux";
import China from "./china/index";
import Province from "./province/index";
import City from "./city/index";
import SupportHospital from "./supportHospital/index";
import RecipientHospital from "./recipientHospital/index";
import { RootState } from "@root/store";

const DataManager = () => {
  const { baseUserCategory } = useSelector(
    (state: RootState) => state.userInfo
  );
  return (
    <div className="datamanager">
      {baseUserCategory === "10" && <China />}
      {baseUserCategory === "11" && <Province />}
      {baseUserCategory === "15" && <City />}
      {baseUserCategory === "13" && <SupportHospital />}
      {baseUserCategory === "12" && <RecipientHospital />}
    </div>
  );
};

export default DataManager;
